export const ACTION = {
    FETCH_BROWSING_FILTERS: 'GET_BROWSING_FILTERS',
    FETCH_BROWSE_BY_DATA: 'FETCH_BROWSE_BY_DATA',
    FETCH_SEARCH_LANDING_DATA: 'FETCH_SEARCH_LANDING_DATA',
    RESET_STATE: 'RESET_STATE',
    RESET_BROWSE_DATA: 'RESET_BROWSE_DATA',
    FETCH_TRENDING_DATA: 'FETCH_TRENDING_DATA',
    FETCH_TA_RECOMMENDED_GENRE_ORDER: 'FETCH_TA_RECOMMENDED_GENRE_ORDER',
    FETCH_TA_RECOMMENDED_LANG_ORDER: 'FETCH_TA_RECOMMENDED_LANG_ORDER',
    FETCH_TA_RECOMMENDED_SEARCH_DATA: 'FETCH_TA_RECOMMENDED_SEARCH_DATA',
    FETCH_TA_RECOMMENDED_SEARCH_GENRE: 'FETCH_TA_RECOMMENDED_SEARCH_GENRE',
    FETCH_TA_RECOMMENDED_SEARCH_LANG: 'FETCH_TA_RECOMMENDED_SEARCH_LANG',
    IS_FETCHING_BROWSE_BY_DATA: "IS_FETCHING_BROWSE_BY_DATA",
    IS_FETCHING_SEARCH_AUTOSUGGESTED_DATA: 'IS_FETCHING_SEARCH_AUTOSUGGESTED_DATA',
    FETCH_SEARCH_AUTOSUGGESTED_DATA: 'FETCH_SEARCH_AUTOSUGGESTED_DATA',
};

export const COMMON_TEXT_VALUE = {
    SHOW_FILTER: 'Show Filter',
    HIDE_FILTER: ' Hide Filter',
};

export const BROWSE_TYPE = {
    LANGUAGE: 'LANGUAGE',
    GENRE: 'GENRE',
    APP_RAIL: 'APP_RAIL',
    PROVIDER: 'PROVIDER',
    CATEGORY:'CATEGORY'
};

export const BROWSE_BY_QUERY_PARAM = {
    FREE_TOGGLE: 'free-toogle'
}